module.exports = __webpack_public_path__ + "static/media/doctor.99ac925e.jpg";